import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditStudentComp from "./Component/EditStudentComp"


const EditStudent =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditStudentComp />
        </div>
        <Footer />
        </>
    )
}

export default EditStudent